import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount, vueVersion } from "./TUIKit/adapter-vue";
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import router from "./router/index";
import { Message } from "element-ui";
import { SDKAppID } from "./main";
import { TUILogin } from "@tencentcloud/tui-core";
import wsManager from "./utils/websocket";
import { getStorage } from "./storage";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const locale = ref<string>("zh");

TUIStore.watch(StoreName.USER, {
  kickedOut: (value: string) => {
    if (value && router.currentRoute.name !== "Login") {
      localStorage.removeItem("TUIKit-userInfo");
      // window.location.assign("/login");
      // localStorage.clear();
    }
  },
});

onMounted(() => {
  let tencent_accid = localStorage.getItem("tencent_accid");
  let tencent_token = localStorage.getItem("tencent_token");

  const loginInfo: any = {
    SDKAppID,
    userID: tencent_accid,
    userSig: tencent_token,
    useUploadPlugin: true,
    framework: `vue${vueVersion}`,
  };
  
  // 修复路由历史访问问题
  let path = router.currentRoute?.path;
  // let path = router.history._startLocation;
  path != "/home/home" &&
    router.currentRoute &&
    tencent_accid &&
    tencent_token &&
    TUILogin.login(loginInfo).catch((error) => {
      Message.error({
        message: error,
      });
    });

  // 初始化WebSocket连接（仅在已登录状态下）
  const token = getStorage('token');
  const userid = getStorage('userid');
  if (token && userid && router.currentRoute.name !== 'Login') {
    console.log('初始化WebSocket连接...');
    wsManager.connect();
  }
});

onBeforeUnmount(() => {
  // 组件销毁时断开WebSocket连接
  wsManager.disconnect();
});

function changeLanguage(language: string) {
  locale.value = language;
}

return { __sfc: true,locale, changeLanguage }
}

})